import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultFieldset: {
    id: 'drinksSection.defaultFieldset',
    defaultMessage: 'Default',
  },
  blockTitle: {
    id: 'drinksSection.blockTitle',
    defaultMessage: 'Section boissons',
  },
  eyebrow: {
    id: 'drinksSection.eyebrow',
    defaultMessage: 'Sur-titre',
  },
  title: {
    id: 'drinksSection.title',
    defaultMessage: 'Titre',
  },
  countLabel: {
    id: 'drinksSection.countLabel',
    defaultMessage: 'Compteur',
  },
  defaultEyebrow: {
    id: 'drinksSection.defaultEyebrow',
    defaultMessage: 'À table',
  },
  defaultTitle: {
    id: 'drinksSection.defaultTitle',
    defaultMessage: 'Nos boissons',
  },
  defaultCountLabel: {
    id: 'drinksSection.defaultCountLabel',
    defaultMessage: 'Apéritifs · vins · bières · chaudes · digestifs',
  },
  showAllergenNotice: {
    id: 'drinksSection.showAllergenNotice',
    defaultMessage: 'Afficher la mention allergènes',
  },
  subcategories: {
    id: 'drinksSection.subcategories',
    defaultMessage: 'Catégories',
  },
  categoryTitle: {
    id: 'drinksSection.categoryTitle',
    defaultMessage: 'Catégorie',
  },
  addCategory: {
    id: 'drinksSection.addCategory',
    defaultMessage: 'Ajouter une catégorie',
  },
  fullWidth: {
    id: 'drinksSection.fullWidth',
    defaultMessage: 'Afficher en pleine largeur',
  },
  image: {
    id: 'drinksSection.image',
    defaultMessage: 'Image (optionnelle)',
  },
  imageDescription: {
    id: 'drinksSection.imageDescription',
    defaultMessage:
      'Bandeau affiché en tête de la catégorie. Format conseillé : paysage 16:9.',
  },
  items: {
    id: 'drinksSection.items',
    defaultMessage: 'Boissons',
  },
  drinkTitle: {
    id: 'drinksSection.drinkTitle',
    defaultMessage: 'Boisson',
  },
  addDrink: {
    id: 'drinksSection.addDrink',
    defaultMessage: 'Ajouter une boisson',
  },
  name: {
    id: 'drinksSection.name',
    defaultMessage: 'Nom',
  },
  price: {
    id: 'drinksSection.price',
    defaultMessage: 'Prix',
  },
  subtitle: {
    id: 'drinksSection.subtitle',
    defaultMessage: 'Sous-titre',
  },
  eyebrowPlaceholder: {
    id: 'drinksSection.eyebrowPlaceholder',
    defaultMessage: 'Sur-titre',
  },
  titlePlaceholder: {
    id: 'drinksSection.titlePlaceholder',
    defaultMessage: 'Titre',
  },
  countLabelPlaceholder: {
    id: 'drinksSection.countLabelPlaceholder',
    defaultMessage: 'Compteur',
  },
  categoryPlaceholder: {
    id: 'drinksSection.categoryPlaceholder',
    defaultMessage: 'Catégorie (Vins, Apéritifs…)',
  },
  removeCategory: {
    id: 'drinksSection.removeCategory',
    defaultMessage: 'Supprimer la catégorie {title}',
  },
  drinkNamePlaceholder: {
    id: 'drinksSection.drinkNamePlaceholder',
    defaultMessage: 'Nom de la boisson',
  },
  drinkSubtitlePlaceholder: {
    id: 'drinksSection.drinkSubtitlePlaceholder',
    defaultMessage: 'Détail (cépage, contenance…)',
  },
  pricePlaceholder: {
    id: 'drinksSection.pricePlaceholder',
    defaultMessage: '0 €',
  },
  priceAriaLabel: {
    id: 'drinksSection.priceAriaLabel',
    defaultMessage: 'Prix',
  },
  removeDrink: {
    id: 'drinksSection.removeDrink',
    defaultMessage: 'Supprimer {title}',
  },
  removeDrinkFallback: {
    id: 'drinksSection.removeDrinkFallback',
    defaultMessage: 'cette boisson',
  },
  emptyState: {
    id: 'drinksSection.emptyState',
    defaultMessage:
      'Aucune catégorie. Cliquez sur « + Ajouter une catégorie ».',
  },
  addDrinkButton: {
    id: 'drinksSection.addDrinkButton',
    defaultMessage: '+ Ajouter une boisson',
  },
  addCategoryButton: {
    id: 'drinksSection.addCategoryButton',
    defaultMessage: '+ Ajouter une catégorie',
  },
});

export default messages;
